import type { FunctionComponent, SVGProps } from "react"

import Altitude from "@/assets/img/today/moon/params/param_altitude.svg?react"
import AngularDiameter from "@/assets/img/today/moon/params/param_angular_diameter.svg?react"
import Azimuth from "@/assets/img/today/moon/params/param_azimuth.svg?react"
import Declination from "@/assets/img/today/moon/params/param_declination.svg?react"
import EclipticLatitude from "@/assets/img/today/moon/params/param_ecliptic_latitude.svg?react"
import EclipticLongitude from "@/assets/img/today/moon/params/param_ecliptic_longitude.svg?react"
import EclipticTilt from "@/assets/img/today/moon/params/param_ecliptic_tilt.svg?react"
import LocalSiderealTime from "@/assets/img/today/moon/params/param_local_sidereal_time.svg?react"
import RightAscension from "@/assets/img/today/moon/params/param_right_ascension.svg?react"

import type { MoonPhasesPayload } from "../../types"

const ICONS: Record<string, FunctionComponent<SVGProps<SVGSVGElement>>> = {
  azimuth: Azimuth,
  altitude: Altitude,
  angularDiameter: AngularDiameter,
  eclipticLongitude: EclipticLongitude,
  eclipticLatitude: EclipticLatitude,
  eclipticTilt: EclipticTilt,
  localSiderealTime: LocalSiderealTime,
  rightAscension: RightAscension,
  declination: Declination,
}

interface MoonParametersProps {
  parameters?: MoonPhasesPayload["parameters"]
}

/** Moon ephemeris parameters list. Ported from MoonPhase MoonParameters. */
export function MoonParameters({ parameters }: MoonParametersProps) {
  if (!parameters?.length) return null

  const items = parameters.map((item) => ({
    key: item.key,
    label: item.label,
    value: item.formatted,
  }))

  return (
    <div className="mt-6 px-4">
      <div className="flex flex-col gap-4 rounded-3xl bg-gradient-to-bl from-purple-light/10 to-purple-light/5 p-4 backdrop-blur-2xl">
        <h3 className="font-display text-xl font-medium text-purple-light">Moon Parameters</h3>
        <div className="flex w-full flex-col gap-2">
          {items.map((item) => {
            const Icon = ICONS[item.key]
            if (!Icon) return null
            return (
              <div key={item.key} className="flex w-full items-center gap-2">
                <div className="flex shrink-0 items-center gap-2 [&_svg]:size-6">
                  <Icon />
                  <span className="whitespace-nowrap font-body text-base text-purple-light/70">
                    {item.label}
                  </span>
                </div>
                <div className="h-px min-w-0 flex-1 bg-purple-light/10" />
                <span className="whitespace-nowrap font-body text-base font-medium text-purple-light">
                  {item.value}
                </span>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
